import { useCallback } from 'react';
import { type PreferenceSchema, prefs } from './registry';

export function usePref<K extends keyof PreferenceSchema>(key: K) {
    return prefs[key].useState() as readonly [PreferenceSchema[K], (v: PreferenceSchema[K]) => void];
}

export function usePrefValue<K extends keyof PreferenceSchema>(key: K): PreferenceSchema[K] {
    return prefs[key].use() as PreferenceSchema[K];
}

export function useSetPref<K extends keyof PreferenceSchema>(key: K) {
    return prefs[key].useSet() as (v: PreferenceSchema[K]) => void;
}

/** Typed batch update — replaces the legacy `dispatch(changeUser({...}))` shape. */
export function patchPrefs(values: Partial<PreferenceSchema>): void {
    for (const [key, value] of Object.entries(values)) {
        if (value === undefined) continue;
        const slot = prefs[key as keyof PreferenceSchema];
        // biome-ignore lint/suspicious/noExplicitAny: dynamic dispatch across heterogeneous prefs
        (slot as { set: (v: any) => void }).set(value);
    }
}

export function useChangeUser() {
    return useCallback(patchPrefs, []);
}
